module.exports = (phoneInput) => {

    return (/^\+?\d{0,3}[" "]*\(?\d{3}\)?[" "]*-*\d{3}[" "]*-*\d{4,6}[" "]*$/).test(phoneInput);
};
